import { Pillars } from 'types/analytics';
import StatisticsCard from 'progress/components/statisticsCard/statisticsCard';
import NoDataBanner from 'progress/components/noDataBanner/noDataBanner';
import PillarPieCard from 'progress/components/pillarPieCard/pillarPieCard';
import ActivityDetailsCard from 'progress/components/activityDetailsCard/activityDetailsCard';
import { Row, Col } from '@whoop/web-components';
import layoutStyles from '../layout.module.scss';

function DailyView() {
  return (
    <>
      <NoDataBanner pillar={Pillars.STRAIN} />
      <Row center="xs" className={layoutStyles.topCardsContainer}>
        <Col xs={4}>
          <PillarPieCard pillar={Pillars.STRAIN} />
        </Col>
        <Col xs={8}>
          <StatisticsCard
            pillar={Pillars.STRAIN}
          />
        </Col>
      </Row>
      <Row center="xs" className={layoutStyles.bottomCardsContainer}>
        <Col xs={12}>
          <ActivityDetailsCard pillar={Pillars.STRAIN} />
        </Col>
      </Row>
    </>
  );
}

export default DailyView;
